<div class="w-full flex align-items-center py-2">
  @if (showStartPoints) {
    <p-select appendTo="body"
              class="dropdown-narrow"
              [options]="startPoints"
              (onChange)="filterChanged()"
              [placeholder]="'PLEASE_SELECT' | translate"
              [disabled]="locked"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="selectedStartPoints"/>

    <p-divider layout="vertical"/>
  }

  @if (showYearMonth) {
    <div class="flex align-items-center gap-2">
      <p-select appendTo="body"
                class="dropdown-narrow"
                [options]="years"
                (onChange)="filterChanged()"
                [placeholder]="'PLEASE_SELECT' | translate"
                [disabled]="locked"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="selectedYear"/>
      @if (selectedYear > 3) {
        <p-select appendTo="body"
                  class="dropdown-narrow"
                  [options]="months"
                  (onChange)="filterChanged()"
                  [placeholder]="'PLEASE_SELECT' | translate"
                  [disabled]="locked"
                  [optionLabel]="view.isMobile ? 'nameShort' : 'name'"
                  optionValue="value"
                  [(ngModel)]="selectedMonth"/>
      }
    </div>
  }

  @if (showYearMonth) {
    <p-divider layout="vertical"/>
  }

  @if (view.isMobile) {
    <!-- TODO Popup wie bei Eventlisten-Filter -->
    <p-button [styleClass]="'p-button-text no-padding ' + (hasFilterDomains() ? ' p-button-success' : '')"
              [icon]="hasFilterDomains() ? 'pi pi-filter-fill' : 'pi pi-filter'"
              (onClick)="overlayPanelMobileFilter.toggle($event)"/>
  } @else {
    <ng-container [ngTemplateOutlet]="templateDomains"/>
  }

  @if (hasFilter()) {
    <p-button (onClick)="clearFilter()" styleClass="p-button-text no-padding" icon="pi pi-eraser"
              [pTooltip]="'CLEAR_FILTER' | translate" [showDelay]="400"/>
  }
</div>

<ng-template #templateDomains let-item="data" pTemplate="item">
  <div class="flex align-items-center gap-2 flex-column md:flex-row">
    @if (showEventType) {
      <div class="w-full">
        @if (this.view.isMobile) {
          <div class="pb-1 text-gray-400">{{ 'TYPE' | translate }}</div>
        }
        <app-dropdown-domain [domainValues]="eventTypeValues" [(value)]="selectedEventTypeCd"
                             (onValueChanged)="filterChanged()" class="w-full" [locked]="locked"/>
      </div>
    }
    <!--@if (showEventKind) {
      <div class="w-full">
        @if (this.view.isMobile) {
          <div class="pb-1 text-gray-400">{{ 'EVENT_KIND' | translate }}</div>
        }
        <app-dropdown-domain [domainValues]="eventKindValues" [(value)]="selectedEventKindCd"
                             (onValueChanged)="filterChanged()" class="w-full" [locked]="locked"/>
      </div>
    }-->
    @if (showMatchType) {
      <div class="w-full">
        @if (this.view.isMobile) {
          <div class="pb-1 text-gray-400">{{ 'MATCH_TYPE' | translate }}</div>
        }
        <app-dropdown-domain [domainValues]="matchTypeValues" [(value)]="selectedMatchTypeCd"
                             (onValueChanged)="filterChanged()" class="w-full" [locked]="locked"/>
      </div>
    }
    @if (showDartType) {
      <div class="w-full">
        @if (this.view.isMobile) {
          <div class="pb-1 text-gray-400">{{ 'DART_TYPE' | translate }}</div>
        }
        <app-dropdown-domain [domainValues]="dartTypeValues" [(value)]="selectedDartTypeCd"
                             (onValueChanged)="filterChanged()" class="w-full" [locked]="locked"/>
      </div>
    }
  </div>
</ng-template>


<p-popover #overlayPanelMobileFilter>
  <ng-container [ngTemplateOutlet]="templateDomains"/>
</p-popover>
